import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_URL_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
} from 'tools/environments';

import { GetByUrlResponse } from './types/get-by-url.type';

export const getByUrl = async (
	url: string,
	lang: string,
	countryCode: string
): Promise<GetByUrlResponse> => {
	const apiUrl = `${PRIVATE_FREEFORM_API_URL_ENV}/web/byurl/?url=${url}&lang=${lang}&countryCode=${countryCode}`;

	try {
		const response: GetByUrlResponse = await fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
				'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
			},
		}).then((res) => res.json());

		return response;
	} catch (error) {
		console.error('Error fetching freeform by URL:', error);
		throw error;
	}
};
